// extracted by mini-css-extract-plugin
export default {"brandPromo":"xJ-z","carousel":"yJ-z"};